// src/Dashboard/pages/user/CalendarEvents/CalendarEventsDashboard.jsx

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScollToTop";

import { useCalendarEvents } from "./hooks/useCalendarEvents";

import CalendarEventsHeader from "./components/CalendarEventsHeader";
import CalendarEventsKpis from "./components/CalendarEventsKpis";
import CalendarEventsToolbar from "./components/CalendarEventsToolbar";
import CalendarEventCard from "./components/CalendarEventCard";
import CalendarEventSkeleton from "./components/CalendarEventSkeleton";
import CalendarEventsEmptyState from "./components/CalendarEventsEmptyState";

export default function CalendarEventsDashboard() {
  useScrollToTop();

  const {
    loading,
    error,

    events,
    filteredEvents,
    visibleEvents,

    favoriteEvents,
    userId,

    ui,
    debouncedSearch,
    setDebouncedSearch,
    updateUi,
    resetFilters,
    loadMore,
    refresh,

    stats,

    typeOptions,
    categoryOptions,
    levelOptions,

    handleFavoriteChange,
  } = useCalendarEvents();

  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5 px-3 sm:px-4 lg:px-6">
        <CalendarEventsHeader loading={loading} onRefresh={refresh} />

        <CalendarEventsKpis stats={stats} loading={loading} />

        <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

          <div className="p-4 sm:p-5 lg:p-6">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                  Événements du club
                </p>

                <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
                  Calendrier des événements
                </h2>

                <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
                  Retrouvez les compétitions, stages, animations, cours communs
                  et passages de grade. Vous pouvez filtrer les événements,
                  gérer vos favoris et inscrire vos adhérents.
                </p>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm dark:border-slate-700 dark:bg-slate-800/60">
                <span className="text-slate-500 dark:text-slate-400">
                  Affichés :
                </span>{" "}
                <span className="font-bold text-slate-900 dark:text-white">
                  {filteredEvents.length}
                </span>
                <span className="text-slate-500 dark:text-slate-400">
                  {" "}
                  / {events.length}
                </span>
              </div>
            </div>

            <div className="mt-5">
              <CalendarEventsToolbar
                ui={ui}
                updateUi={updateUi}
                debouncedSearch={debouncedSearch}
                setDebouncedSearch={setDebouncedSearch}
                typeOptions={typeOptions}
                categoryOptions={categoryOptions}
                levelOptions={levelOptions}
                onReset={resetFilters}
              />
            </div>

            {loading ? (
              <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {Array.from({ length: 6 }).map((_, index) => (
                  <CalendarEventSkeleton key={index} />
                ))}
              </div>
            ) : error ? (
              <div className="mt-5 rounded-[24px] border border-red-200 bg-red-50 px-5 py-8 text-center text-sm text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300">
                {error}
              </div>
            ) : filteredEvents.length === 0 ? (
              <CalendarEventsEmptyState
                favoriteOnly={ui.favoriteOnly}
                onReset={resetFilters}
              />
            ) : (
              <>
                <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  {visibleEvents.map((event) => (
                    <CalendarEventCard
                      key={event.id}
                      event={event}
                      userId={userId}
                      isFavorite={favoriteEvents.includes(event.id)}
                      onFavoriteChange={handleFavoriteChange}
                    />
                  ))}
                </div>

                {visibleEvents.length < filteredEvents.length && (
                  <div className="mt-6 flex justify-center">
                    <button
                      type="button"
                      onClick={loadMore}
                      className="rounded-2xl bg-[#013E8E] px-5 py-3 text-sm font-bold text-white transition hover:bg-indigo-800"
                    >
                      Charger plus
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </section>
      </div>

      <ToastContainer />
    </section>
  );
}